import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex gap-10 flex-col max-w-7xl mx-auto justify-center mt-28 ml-[22.5%]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl uppercase font-semibold text-[#322121] dark:text-white" }, " View Documents ", -1)
const _hoisted_3 = { class: "relative w-full sm:rounded-lg mb-20" }
const _hoisted_4 = {
  key: 0,
  class: "mb-10 w-full border dark:border-gray-600 text-sm text-left text-gray-500 dark:text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Title"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Download"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Edit"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Delete")
  ])
], -1)
const _hoisted_6 = { class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" }
const _hoisted_7 = { class: "px-6 py-4" }
const _hoisted_8 = {
  scope: "row",
  class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
}
const _hoisted_9 = { class: "px-6 py-4" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "px-6 py-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "px-6 py-4" }
const _hoisted_14 = ["onClick"]

import { url } from '@/functions/endpoint';
import { encryptString } from '@/functions/encryption';
import axios from 'axios';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import { Pagination } from 'flowbite-vue';
import { Posts } from "@/types/index";
import Loader from "@/components/Loader.vue";
import EmptyState from "@/components/EmptyState.vue";
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDocuments',
  setup(__props) {

let count = ref(0);
const documentId = ref();
const router = useRouter()
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
let emptyState = ref(false);
const perPage = ref(12);
const currentPage = ref(1);

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const editDocument = (documentId: number) => {
  router.push({ name: 'EditDocument', params: { id: encryptString(documentId.toString()) } });
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  documentId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteDocument = () => {
  axios.delete(`${url}/department-document/delete/${documentId.value}`)
    .then((response) => {
      deleteModal.value = false;
      successMessage = response.data
      showSuccessMessage.value = true;
      const deletedIndex = allDocuments.value.findIndex((item: Posts) => item.id === parseInt(documentId.value));
      if (deletedIndex !== -1) {
        allDocuments.value.splice(deletedIndex, 1);
      }
      setTimeout(() => {
        showSuccessMessage.value = false;
      }, 2000)
    })
    .catch((error) => {
      deleteModal.value = false;
      errorAlert.value = true;
      setTimeout(() => {
        errorAlert.value = false;
      }, 2500)
      errorMessage.value = error.message
    });
};

const allDocuments: any = ref([]);
const fetchNewsItems = () => {
  loading.value = true;
  emptyState.value = false;
  axios
    .get(`${url}/department-document`, {
      params: {
        page: currentPage.value,
        limit: perPage.value
      }
    })
    .then((response: any) => {
      allDocuments.value = response.data;
      // count.value = response.data[0].totalLength;
    })
    .catch((error: string) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDocuments.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: item.id
                }, [
                  _createElementVNode("tr", _hoisted_6, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item?.title?.slice(0, 80)), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: item.filename
                      }, "Download", 8, _hoisted_10)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (editDocument(item.id)),
                        class: "font-medium text-blue-600 dark:text-blue-500 hover:underline"
                      }, "Edit", 8, _hoisted_12)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "font-medium text-red-600 dark:text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_14)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(Loader, {
              key: 1,
              class: "my-52"
            })),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"]),
        (allDocuments.value.length > 12)
          ? (_openBlock(), _createBlock(_unref(Pagination), {
              key: 2,
              modelValue: currentPage.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
              "per-page": perPage.value,
              "total-items": _unref(count),
              layout: 'table'
            }, null, 8, ["modelValue", "per-page", "total-items"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteDocument,
          onCloseDeleteModal: closeDeleteModal,
          item: 'document'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})